import { includedType } from "@/common/const/types/index.const";
const includedOptions = includedType.map((el) => ({
  label: el,
  value: el,
}));

export default includedOptions;
